/**
 * SuperAdmin platform health — /superadmin/health (route shell).
 *
 * Screen impl in `./health-screen.tsx`, lazy-loaded. Platform-operator-only
 * surface (behind the /superadmin layout gate) — never on a trustee's path.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/health')({
  component: lazyRouteComponent(() => import('./health-screen'), 'PlatformHealthPage'),
});
